export const GET_STREAM_CONTENTS = 'GET_STREAM_CONTENTS';
export const INCREMENT_STREAMING_CONTENT_VIEW =
  'INCREMENT_STREAMING_CONTENT_VIEW';
export const AGREEMEMT_STREAMING_CONTENT_POLICY =
  'AGREEMEMT_STREAMING_CONTENT_POLICY';
export const FAILURE_PURCHASE = 'FAILURE_PURCHASE';
export const FAILURE_FORBIDDEN = 'FAILURE_FORBIDDEN';
export const FETCH_STREAMING_CONTENT_GROUP_ID =
  'FETCH_STREAMING_CONTENT_GROUP_ID';
